import * as React from "react";
import Accordion from "@mui/material/Accordion";

import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { totalPriceCounter } from "@/services/API/totalPriceCounter";
import priceFormatter from "@/utils/priceFormatter";
import Title from "@/shared/components/Title/Title";
import formattedDate from "@/utils/formattedDate";

import { IStatisticItemProps } from "@/shared/interfaces/Statistic";

import "./StatisticListingItem.scss";

export default function StatisticListingItem({ item }: IStatisticItemProps) {
    const { patientId, doctorId, services, paymentHistory } = item;
    const totalServices = totalPriceCounter(services);

    const totalPayment = paymentHistory.reduce(
        (accum, item) => accum + Number(item.amount),
        0,
    );

    return (
        <li key={item._id}>
            <Accordion
                key={item._id}
                sx={{
                    backgroundColor: "#F6F9F9",
                    border: "1px solid #DCE0E5",
                    boxShadow: "none",
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1-content'
                    id='panel1-header'
                >
                    <div className='stat_listing_item_title_container'>
                        <p className='stat_listing_item_title'>
                            {patientId?.name
                                ? patientId?.name
                                : "Пацієнта видалено з бази"}
                        </p>
                        <p className='stat_listing_item_doctor_name'>
                            {doctorId?.name
                                ? doctorId?.name
                                : "Лікаря видалено з бази"}
                        </p>
                        <div className='stat_listing_item_payment_container'>
                            <p className='stat_listing_item_total'>
                                <span>Всього:</span>
                                <span>{priceFormatter(totalServices)}</span>
                            </p>
                            <p className='stat_listing_item_payment'>
                                <span>Сплачено:</span>
                                <span>{priceFormatter(totalPayment)}</span>
                            </p>
                            <p className='stat_listing_item_debt'>
                                <span> Борг:</span>
                                <span>
                                    {priceFormatter(
                                        totalServices - totalPayment,
                                    )}
                                </span>
                            </p>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <Title
                        tag='h4'
                        text={"Послуги"}
                        style={{ color: "black" }}
                    />
                    <ul className='stat_listing_item_service_listing'>
                        {services.length > 0 ? (
                            services.map((item, index) => (
                                <li
                                    className='stat_listing_item_service_item'
                                    key={item._id}
                                >
                                    <p>{item.title}</p>
                                    <dl className='stat_listing_item_service_dlist'>
                                        <div className='stat_quantity'>
                                            <dt>Кл-ть</dt>
                                            <dd>{item.quantity}</dd>
                                        </div>
                                        <div className='stat_discount'>
                                            <dt>%</dt>
                                            <dd>{item.discount}</dd>
                                        </div>
                                        <div className='stat_price'>
                                            <dd>
                                                {priceFormatter(item.price)} грн
                                            </dd>
                                        </div>
                                    </dl>
                                </li>
                            ))
                        ) : (
                            <p className='stat_listing_paragraf'>
                                Послуги відсутні
                            </p>
                        )}
                    </ul>
                    <Title
                        tag='h4'
                        text={"Платежі"}
                        style={{ color: "black", marginTop: 20 }}
                    />
                    <ul className='stat_listing_item_service_listing listing_payments'>
                        {item.paymentHistory.length > 0 ? (
                            item.paymentHistory.map((item, index) => (
                                <li
                                    className='stat_listing_item_service_item'
                                    key={item.amount}
                                >
                                    <div className='stat_listing_item_payment_container'>
                                        <p className='stat_listing_item_payment'>
                                            Дата:{" "}
                                            <span>
                                                {formattedDate(item.date)}
                                            </span>
                                        </p>
                                    </div>
                                    <div className='stat_listing_item_payment_container'>
                                        <p className='stat_listing_item_payment'>
                                            Сума:{" "}
                                            <span>
                                                {priceFormatter(item.amount)}
                                            </span>
                                        </p>
                                    </div>
                                </li>
                            ))
                        ) : (
                            <p className='stat_listing_paragraf'>
                                Платежі відсутні
                            </p>
                        )}
                    </ul>
                </AccordionDetails>
            </Accordion>
        </li>
    );
}
